/**
 * Frontend kill switch for the Trend/Record Visualization page.
 *
 * Semantics: ENABLED unless explicitly turned off. The backend flag
 * (MARCH_TREND_VIZ__ENABLED, default off) is the real gate — its endpoints
 * answer 404 when disabled and the page shows a "not enabled" state. This
 * VITE flag only exists to hide the entry button without a backend deploy;
 * unset means visible, so the deployed build needs no extra env plumbing.
 */
export function isTrendVizUiEnabled(): boolean {
  const raw = (import.meta.env.VITE_TREND_VIZ_ENABLED ?? '')
    .toString()
    .trim()
    .toLowerCase();
  return !['0', 'false', 'off', 'no'].includes(raw);
}
